export default "__VITE_ASSET__CAW2EYjL__"